import React, { useEffect } from 'react';
import { Button, Form, Input, message } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import './index.css';

interface LoginFormData {
  username: string;
  password: string;
}

const LoginGlassPage: React.FC = () => {
  const [form] = Form.useForm<LoginFormData>();
  const navigate = useNavigate();
  const location = useLocation();
  const { login, loading, error, clearError, isAuthenticated } = useAuthStore();

  useEffect(() => {
    // 如果带有 preview 参数，则不跳转
    const params = new URLSearchParams(location.search);
    const isPreview = params.get('preview') === '1';

    if (isAuthenticated && !isPreview) {
      const from = (location.state as any)?.from?.pathname || '/dashboard';
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, location]);

  useEffect(() => {
    if (error) {
      message.error(error);
      clearError();
    }
  }, [error, clearError]);

  const handleLogin = async (values: LoginFormData) => {
    const result = await login(values);
    if (result.success) {
      message.success(result.message);
      // 登录成功后，如果是预览模式，依然保持在当前页；否则跳转
      const params = new URLSearchParams(location.search);
      const isPreview = params.get('preview') === '1';
      
      if (!isPreview) {
        const from = (location.state as any)?.from?.pathname || '/dashboard';
        navigate(from, { replace: true });
      }
      return;
    }
    message.error(result.message);
  };

  return (
    <div className="glass-body-wrapper">
      {/* 背景装饰 */}
      <div className="glass-orb one" />
      <div className="glass-orb two" />

      <div className="glass-container fade-in">
        <div className="glass-panel">
          <div className="glass-header">
            <h1>欢迎回来</h1>
            <p>斌宇林建项目管理系统</p>
          </div>

          <Form
            form={form}
            name="login-glass"
            onFinish={handleLogin}
            className="glass-form"
          >
            <div className="glass-form-group">
              <Form.Item
                name="username"
                rules={[{ required: true, message: '请输入用户名' }]}
                style={{ margin: 0 }}
              >
                <Input 
                  className="glass-input" 
                  placeholder="用户名" 
                  autoComplete="username" 
                  variant="borderless" // 移除 Antd 默认边框，使用 CSS 自定义
                />
              </Form.Item>
            </div>
            
            <div className="glass-form-group">
              <Form.Item 
                name="password" 
                rules={[{ required: true, message: '请输入密码' }]}
                style={{ margin: 0 }}
              >
                <Input.Password 
                  className="glass-input" 
                  placeholder="密码" 
                  autoComplete="current-password"
                  variant="borderless"
                />
              </Form.Item>
            </div>

            <Button 
              htmlType="submit" 
              className="glass-btn" 
              loading={loading}
              id="loginBtn"
            >
              登 录
            </Button>
          </Form>

          <div className="glass-footer">
            <p>© 2026 Kiro Prototype Lab</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginGlassPage;
